module.exports = {"411628001":"真源","411628002":"谷阳","411628003":"卫真","411628004":"鸣鹿","411628100":"涡北镇","411628101":"玄武镇","411628102":"宋河镇","411628103":"太清宫镇","411628104":"王皮溜镇","411628105":"试量镇","411628106":"辛集镇","411628107":"马铺镇","411628108":"贾滩镇","411628109":"杨湖口镇","411628110":"张店镇","411628111":"观堂镇","411628112":"生铁冢镇","411628200":"郑家集乡","411628204":"赵村乡","411628205":"任集乡","411628206":"唐集乡","411628207":"高集乡","411628208":"邱集乡","411628209":"穆店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411628.json
// module id = 1683
// module chunks = 0